import { Injectable } from '@angular/core';
import { PopupSettingService } from '@rd/popup/services/popup-setting/popup-setting.service';
import { ButtonTheme } from '@rd/types';

@Injectable({
  providedIn: 'root',
})
export class WestpacPopupSettingService extends PopupSettingService {
  userIdleDialogButtonTheme: ButtonTheme = 'outline-primary';
}
